import authAxios from "../utils/authAxios"
import { toast } from "react-toastify"
import { useCallback, useState, useMemo } from "react"
import { logout } from "../services/auth"

const useAuthAxios = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const doApiCall = useCallback(async (method, url, data, silentFail) => {
    setLoading(true)
    setError(false)
    try {
      const response = await authAxios[method](url, data)

      // If response type is blob, return the entire response
      if (response.config?.responseType === "blob") {
        return response
      }

      // For JSON responses, check success status
      if (!response.data?.success) {
        if (response.status === 401 || response?.data?.error?.response?.status === 401) {
          if (
            !window.location.pathname.startsWith("/login") &&
            !window.location.pathname.startsWith("/register") &&
            !window.location.pathname.startsWith("/password-reset") &&
            !window.location.pathname.startsWith("/register") &&
            !window.location.pathname.startsWith("/forgot-password")
          ) {
            await logout()
            window.location.href = "/login"
          }
          silentFail = true
        }

        if (response.data?.error?.message === "Request failed with status code 413") {
          response.data.error.message = "Το μέγεθος του request ήταν πολύ μεγάλο."
        }

        if (!silentFail) {
          toast.error(
            !response.data?.error?.handled
              ? "Προέκυψε κάποιο πρόβλημα. Παρακαλώ δοκιμάστε ξανά ή επαναφορτώστε τη σελίδα."
              : (!response.data?.error?.handled ? "Σφάλμα: " : "") +
                  (response.data?.error?.details || response.data?.error?.message),
            { autoClose: false }
          )
          console.log("Backend call error", response.data?.error)
        }

        setError(true)
      }
      return response.data
    } catch (err) {
      toast.error(err.message)
      setError(true)
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  const methods = useMemo(
    () => ({
      get: async (url, params, silentFail = false) => await doApiCall("get", url, params, silentFail),
      post: async (url, data = null, silentFail = false) => await doApiCall("post", url, data, silentFail),
      put: async (url, data = null, silentFail = false) => await doApiCall("put", url, data, silentFail),
      del: async (url, data = null, silentFail = false) => await doApiCall("delete", url, data, silentFail)
    }),
    [doApiCall]
  )

  // Return methods and state separately
  return { ...methods, loading, error }
}

export default useAuthAxios
